import { angularServicesNames } from "@topline/services/angularServicesNames";

(function (module) {
  "use strict";

  module.service("modalService", [
    angularServicesNames.$uibModal,
    angularServicesNames.$translate,
    "$sce",
    function(this: $TSFixMe, $uibModal: ng.ui.bootstrap.IModalService, $translate: ng.translate.ITranslateService, $sce: ng.ISCEService) {
      var service = this;

      service.showConfirmationModal = function (translationKey: $TSFixMe, successCallback: $TSFixMe, denyCallback: $TSFixMe, mode: $TSFixMe) {
        var defaults = {
          okText: $translate.instant("YES"),
          cancelText: $translate.instant("CANCEL"),
          title: "",
          text: "",
        };

        var contents =
          typeof translationKey == "string"
            ? Object.assign({}, defaults, { text: $translate.instant(translationKey) })
            // @ts-expect-error ts-migrate(2550) FIXME: Property 'fromEntries' does not exist on type 'Obj... Remove this comment to see the full error message
            : Object.assign({}, defaults, Object.fromEntries(Object.entries(translationKey).map(([k, key]) => [k, $translate.instant(key)])));

        service.showConfirmationModalStr(contents, successCallback, denyCallback, mode);
      };

      service.showConfirmationModalStr = function (content: $TSFixMe, successCallback: $TSFixMe, denyCallback: $TSFixMe, mode: $TSFixMe) {
        var defaults = {
          okText: $translate.instant("YES"),
          cancelText: $translate.instant("CANCEL"),
          title: "",
          text: "",
        };

        content = content.$$unwrapTrustedValue ? content : content;

        var contents = typeof content == "string" ? Object.assign({}, defaults, { text: content }) : Object.assign({}, defaults, content);

        // @ts-expect-error ts-migrate(2550) FIXME: Property 'fromEntries' does not exist on type 'Obj... Remove this comment to see the full error message
        contents = Object.fromEntries(Object.entries(contents).map(([k, v]) => [k, v.$$unwrapTrustedValue ? v : v]));

        var modalInstance = $uibModal.open({
          component: "modalConfirm",
          windowClass: "modal-confirm",
          resolve: {
            text: function () {
              return $sce.trustAsHtml(contents.text);
            },
            title: function () {
              return $sce.trustAsHtml(contents.title);
            },
            okText: function () {
              return $sce.trustAsHtml(contents.okText);
            },
            cancelText: function () {
              return $sce.trustAsHtml(contents.cancelText);
            },
            mode: function () {
              return mode || "info";
            },
          },
        });

        modalInstance.result.then(
          () => {
            if(successCallback) successCallback();
          },
          () => {
            if (denyCallback) denyCallback();
          }
        );
      };

      service.showErrorModalStr = function (content: $TSFixMe) {
        var defaults = {
          okText: $translate.instant("OK"),
          title: "",
          text: "",
        };

        content = content.$$unwrapTrustedValue ? content : content;

        var contents = typeof content == "string" ? Object.assign({}, defaults, { text: content }) : Object.assign({}, defaults, content);

        // @ts-expect-error ts-migrate(2550) FIXME: Property 'fromEntries' does not exist on type 'Obj... Remove this comment to see the full error message
        contents = Object.fromEntries(Object.entries(contents).map(([k, v]) => [k, v.$$unwrapTrustedValue ? v : v]));

        $uibModal.open({
          component: "modalError",
          windowClass: "modal-confirm",
          resolve: {
            text: function () {
              return $sce.trustAsHtml(contents.text);
            },
            title: function () {
              return $sce.trustAsHtml(contents.title);
            },
            okText: function () {
                return $sce.trustAsHtml(contents.okText);
            }
          },
        });
      };
    },
  ]);

})(angular.module("topline.app"));
